/** Разрешённый сотрудник для загрузки бумажного скана BUH_AVR (admin.employee_tab). */
export const BUH_AVR_MANUAL_SCAN_ALLOWED_EMPLOYEE_ID = 2277;

export function canAccessBuhAvrManualScanUpload(employeeId) {
  return Number(employeeId) === BUH_AVR_MANUAL_SCAN_ALLOWED_EMPLOYEE_ID;
}

/** Есть ли хотя бы один подписанный слот в assign_signs. */
export function buhAvrHasAnyAssignSign(row) {
  const signs = row?.assign_signs;
  if (!Array.isArray(signs) || signs.length === 0) return false;
  return signs.some((s) => s.is_signed === true || s.is_signed === 1);
}

/** Признак «есть подпись» для BUH_AVR (флаг have_signed или assign_signs). */
export function buhAvrRowHaveSigned(row) {
  if (!row) return false;
  if (row.have_signed === true || row.have_signed === 1) return true;
  return buhAvrHasAnyAssignSign(row);
}

/** Отправлен ли АВР в 1С (разные API: Documents vs ClosingDocuments). */
export function buhAvrRowIsSentBi(row) {
  if (!row) return false;
  return row.is_avr_sent_bi === true
    || row.is_avr_sent_bi === 1
    || row.is_sent_bi === true
    || row.is_sent_bi === 1;
}

/** Код типа документа (BUH_AVR). */
export function buhAvrRowTypeCode(row) {
  return row?.floor_map_document_type_code || row?.type_code || null;
}

/** Причина блокировки загрузки; null — можно загружать. */
export function getBuhAvrManualScanBlockReason(row) {
  if (!row) return "Документ не найден";

  if (buhAvrRowTypeCode(row) !== "BUH_AVR") {
    return "Доступно только для бухгалтерского АВР (BUH_AVR)";
  }

  const status = row.status_code || row.floor_map_document_status_code;
  if (status === "CANCELLED") {
    return "Документ отменён";
  }

  if (row.is_manual_signed === true || row.is_manual_signed === 1) {
    return "Бумажный скан уже загружен";
  }

  if (buhAvrRowIsSentBi(row)) {
    return "Документ уже отправлен в 1С";
  }

  if (buhAvrRowHaveSigned(row)) {
    return "У документа уже есть подпись";
  }

  return null;
}

export function canUploadBuhAvrManualScan(row) {
  return !getBuhAvrManualScanBlockReason(row);
}

/** DD.MM.YYYY для модалки: sign_date / document_date / doc_date / сегодня. */
export function defaultBuhAvrManualSignDate(row) {
  const raw = row?.sign_date || row?.document_date || row?.doc_date;
  if (raw) {
    const s = String(raw);
    const mDmY = s.match(/^(\d{2})\.(\d{2})\.(\d{4})/);
    if (mDmY) return `${mDmY[1]}.${mDmY[2]}.${mDmY[3]}`;
    const mYmd = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (mYmd) return `${mYmd[3]}.${mYmd[2]}.${mYmd[1]}`;
  }
  const d = new Date();
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const yyyy = d.getFullYear();
  return `${dd}.${mm}.${yyyy}`;
}
